// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1y7Eq","question":"styles_question__3okwH","inputVisibleButton":"styles_inputVisibleButton__3Alet","note":"styles_note__1l3Ir"};